import Paging from "src/app/model/api/generic/paging";
import InspeccionClass from "src/app/model/api/inspecciones/inspeccionClass";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class OrdenesTrabajoTable extends DatabaseTable<InspeccionClass> {

    public async getAll(): Promise<InspeccionClass[]> {
        return await this.GetAllRecords()
    }

    public async getById(Id: number): Promise<InspeccionClass> {
        let records = await this.GetRecordsByIndex(0, 1, 'Id', Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByLocalId(Id: number): Promise<InspeccionClass> {
        let records = await this.GetRecordsById(0, 1, Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getPaged(start: number, limit: number): Promise<Paging<InspeccionClass>> {
        let count = await this.GetRecordsCount()
        let data = await this.GetRecordsPage(start, limit)

        let result = new Paging<InspeccionClass>()
        result.page = Math.floor(start / limit) + 1
        result.total = count
        result.totalPages = Math.ceil(result.total / limit)
        result.collection = data
        result.count = data.length
        return result
    }

    public async getPagedSearch(start: number, limit: number, filtro_busqueda: string): Promise<Paging<InspeccionClass>> {
        let allData = await this.GetAllRecords()
        let allDataFiltered = allData
        if (filtro_busqueda != null && filtro_busqueda != '') {
            allDataFiltered = allData.filter(p => {
                if (p.Inspeccion.toLowerCase().indexOf(filtro_busqueda.toLowerCase()) != -1) return true
                if (p.Codigo.toLowerCase().indexOf(filtro_busqueda.toLowerCase()) != -1) return true
                if (p.NumInforme.toLowerCase().indexOf(filtro_busqueda.toLowerCase()) != -1) return true
                if (p.Id.toString() == filtro_busqueda) return true
                return false
            })
        }

        let result = new Paging<InspeccionClass>
        result.page = Math.floor(start / limit) + 1
        result.total = allDataFiltered.length
        result.totalPages = Math.ceil(result.total / limit)
        
        // Aplicamos paginado.
        allDataFiltered = allDataFiltered.slice(start, start + limit)
        result.collection = allDataFiltered
        result.count = allDataFiltered.length
        return result
    }

    public async update(record: InspeccionClass): Promise<number> {
        return await this.UpdateRecord(record)
    }

    public async delete(record: InspeccionClass): Promise<void> {
        if (!record?.LocalId) return
        await this.DeleteRecord(record.LocalId)
    }

    public async count(): Promise<number> {
        return await this.GetRecordsCount()
    }

}